import React from 'react';
import { cn } from '@/utils/helpers/classnames';
import { Loader } from 'lucide-react';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const variantStyles: Record<ButtonVariant, string> = {
  primary: 'bg-[#047857] hover:bg-[#059669] text-white',
  secondary: 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50',
  danger: 'bg-wine-100 hover:bg-wine-200 text-white',
  ghost: 'bg-transparent text-gray-700 hover:bg-gray-100'
};

const sizeStyles: Record<ButtonSize, string> = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base'
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  icon,
  children,
  disabled,
  className = '',
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn("font-semibold rounded-md transition-colors inline-flex items-center gap-2 justify-center disabled:opacity-50 disabled:cursor-not-allowed", variantStyles[variant], sizeStyles[size],  className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <Loader size="xs"  className="mr-2" />}
      {!loading && icon}
      {children}
    </button>
  );
}

export default Button;
